// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { ILevelDomainDto } from 'src/app/infrastructure/models/level-domain-dto';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { IProjectCategoryData, projectCategoryData } from 'src/app/features/project-category/models/project-category-data';

export const projectCategoryDto = {
    guid: 'guid',
    nr: 'nr',
    description: 'description',
    inactive: 'inactive',
    deleted: 'deleted',
} as const;

export type TProjectCategoryDto = (typeof projectCategoryDto)[keyof typeof projectCategoryDto];

export const projectCategoryDtoConstraints = {
    description: { required: true },
} as const;

export type TProjectCategoryDtoConstraints = typeof projectCategoryDtoConstraints;

export interface IProjectCategoryDto extends ILevelDomainDto {
    [projectCategoryDto.guid]: string | null;
    [projectCategoryDto.nr]: number | null;
    [projectCategoryDto.description]: string | null;
    [projectCategoryDto.inactive]: boolean | null;
    [projectCategoryDto.deleted]: boolean | null;
}

export class ProjectCategoryDto
    implements IProjectCategoryDto
{
    [projectCategoryDto.guid]: string | null = null;
    [projectCategoryDto.nr]: number | null = null;
    [projectCategoryDto.description]: string | null = null;
    [projectCategoryDto.inactive]: boolean | null = null;
    [projectCategoryDto.deleted]: boolean | null = null;

    private constructor(
        modelData?: IProjectCategoryData
    ) {
        if (!modelData || isEmptyObject(modelData)) return;

        this[projectCategoryDto.guid] = modelData[projectCategoryData.guid];
        this[projectCategoryDto.nr] = modelData[projectCategoryData.nr];
        this[projectCategoryDto.description] = modelData[projectCategoryData.description];
        this[projectCategoryDto.deleted] = modelData[projectCategoryData.deleted];
        this[projectCategoryDto.inactive] = modelData[projectCategoryData.inactive];
    }

    static create(modelData?: IProjectCategoryData | null): IProjectCategoryDto | null {
        return modelData ? new ProjectCategoryDto(modelData) : null;
    }
}
